import api from "@/router/api";

export default {
  async deletGrupoAtividade(grupoId) {
    const response = await api.delete(`/grupo/${grupoId}`);
    return response.data;
  },
};
